import React, { Component } from 'react';
import type { ReactNode } from 'react';
import Logo from '../../../../assets/images/timesheets_logo_border.svg';
import type { User } from '../../../types';

type Props = {
  navigate: any,
  currentUser?: User,
  hasActiveIncidents?: boolean,
  onOpenCheckinModal?: () => void,
}

class NavSmallScreen extends Component<Props, any> {
  render(): ReactNode {
    const { currentUser, onOpenCheckinModal, hasActiveIncidents, navigate } = this.props;
    const isAdmin = currentUser?.role === 'admin';
    const isOwner = currentUser?.role === 'owner';

    return (
      <div className="container-fluid device-small main-nav">
        <div className="row">
          <nav className="navbar navbar-default nav-flex-small">
            <div className="image-wrapper" onClick={this.handleLogoClick}>
              <img src={Logo} alt="logo" className="nav-logo" />
            </div>
            <div className="d-flex align-items-center">
              {(isAdmin || isOwner) && (
                <span style={{ cursor: 'pointer', marginRight: '12px', marginTop: '10px', display: 'flex', alignItems: 'center' }} onClick={() => navigate('/incidents')}>
                  <i className="fa fa-exclamation-triangle"
                     style={{ color: hasActiveIncidents ? '#f0ad4e' : '#ccc', fontSize: '16px' }} />
                </span>
              )}
              {currentUser && currentUser.needsRemoteCheckin && (
                <button
                  type="button"
                  className="btn btn-primary primary-color me-2"
                  onClick={onOpenCheckinModal}
                  style={{ fontSize: '12px', padding: '6px 12px' }}
                >
                  Check In
                </button>
              )}
              <button
                className="btn menu-bars"
                type="button"
                data-toggle="collapse"
                data-target="#menu"
                aria-controls="menu"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="fa fa-bars fa-2x" aria-hidden="true" />
              </button>
            </div>
          </nav>
        </div>
      </div>
    );
  }

  handleLogoClick = () => {
    const { navigate } = this.props;
    navigate('/');
  };
}

export default NavSmallScreen;
